import { parse } from 'csv-parse/browser/esm';

const normalizeHeader = (header) => {
	if (typeof header !== 'string') return '';

	return header
		?.toLowerCase()
		?.trim()
		?.normalize('NFD')
		?.replace(/[\u0300-\u036f]/g, '')
		?.replace(/\W/g, '_');
};

const CSVInput = ({ setLoadFile, skipLines = 0 }) => {
	const handleFile = (event) => {
		const file = event.target.files?.[0];

		if (!file) {
			setLoadFile(null);
			return;
		}

		const reader = new FileReader();

		reader.onload = () => {
			const text = reader.result;

			parse(
				text,
				{
					columns: (header) => header.map(normalizeHeader),
					skip_empty_lines: true,
					from_line: skipLines,
					trim: true,
				},
				(err, records) => {
					if (err) {
						console.error('CSV parse error:', err);
						setLoadFile(null);
						return;
					}

					setLoadFile(records);
				},
			);
		};

		reader.onerror = () => {
			console.error('File read error');
			setLoadFile(null);
		};

		reader.readAsText(file);
	};

	return (
		<input
			type='file'
			accept='.csv,text/csv'
			className='csv-reader-input'
			style={{ color: 'red' }}
			onChange={handleFile}
		/>
	);
};

export default CSVInput;
